import dayjs from "dayjs";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Form, Row, Col, DatePicker, Space, Button, Divider, Select } from "antd";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { useAppSelector, useAppDispatch } from "../../../../util/hooks";
import { realParaNumber } from "../../../../util/dinheiroBRAuxiliar";
import { atualizarLancamentoControleAporte, cadastrarLancamentoControleAporte } from "../../../../services/lancamentoControleAporteService";
import { LancamentoControleAporteModel } from "../../../../models/lancamentoControleAporte/lancamentoControleAporteModel";
import { setModalCadastrarLancamentoControleAporte } from "../../../../redux/slices/lancamentoControleAporte/lancamentoControleAporteSlice";

type FormProps = {
  dataPrevistaRecebimento: Date;
  idSorteio: number;
  valor: number;
};

const CadastroLancamentoControleAporte = () => {
  //estados globais
  const sorteioState = useAppSelector((state) => state.sorteio);
  const lancamentoControleAporteState = useAppSelector((state) => state.lancamentoControleAporte);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<FormProps>();

  const editar = Object.values(lancamentoControleAporteState.entity).length !== 0;

  useEffect(() => {
    if (editar) {
      form.setFieldsValue({
        dataPrevistaRecebimento: dayjs(lancamentoControleAporteState.entity.dataLancamento),
        idSorteio: lancamentoControleAporteState.entity.idSorteio,
        valor: lancamentoControleAporteState.entity.valor,
      });
    }
  }, [lancamentoControleAporteState.entity]);

  const submit = (values: FormProps) => {
    if (editar) {
      let atualizar = { idLancamento: lancamentoControleAporteState.entity.idLancamentoControleAporte, idSorteio: values.idSorteio };
      dispatch(atualizarLancamentoControleAporte({ value: atualizar, busca: lancamentoControleAporteState.busca }));
    } else {
      var cadastrar = { ...values, dataLancamento: dayjs(values.dataPrevistaRecebimento).toDate(), valor: realParaNumber(values.valor.toString()) };
      dispatch(cadastrarLancamentoControleAporte({ value: cadastrar, busca: lancamentoControleAporteState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarLancamentoControleAporte(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={12}>
        <Col span={8}>
          <Form.Item
            label="Data do recebimento"
            name="dataPrevistaRecebimento"
            rules={[
              {
                required: true,
                message: "Digite uma data",
              },
            ]}
          >
            <DatePicker format="DD/MM/YYYY" allowClear={false} style={{ width: "100%" }} disabled={editar} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Data do sorteio"
            name="idSorteio"
            rules={[
              {
                required: true,
                message: "Selecione uma data de sorteio",
              },
            ]}
          >
            <Select
              showSearch
              loading={sorteioState.loadingEmpresas}
              optionLabelProp="label"
              style={{ width: "100%" }}
              options={sorteioState.listSorteioEmpresas.map((a: any) => ({
                value: a.idSorteio,
                label: dayjs(a.dataSorteio).format("DD/MM/YYYY"),
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Valor"
            name="valor"
            rules={[
              {
                required: true,
                message: "Digite um valor",
              },
            ]}
          >
            <NumericFormat
              style={{ width: "100%" }}
              className="ant-input noBoderColor number-input"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              disabled={editar}
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroLancamentoControleAporte;
